<template>
  <nav
    aria-label="Formularfortschritt"
    class="progress"
  >

    <button
      :aria-controls="id"
      :aria-expanded="expanded ? 'true' : 'false'"
      :aria-label="`Fortschritt ${expanded ? 'ausblenden' : 'einblenden'}`"
      :class="{ 'is-expanded': expanded }"
      class="progress__button"
      type="button"
      @click="expanded = !expanded"
    >

      <span class="progress__button-chip">
        <b>{{ current + 1 }}</b> von <b>{{ steps.length }}</b>
      </span>

      {{ steps[current].title }}

    </button>

    <ol
      :class="{ 'is-expanded': expanded }"
      :id="id"
      :key="current"
      class="progress__list"
    >
      <li
        v-for="(step, index) in steps"
        :aria-current="current === index ? 'step' : null"
        :key="index"
        class="progress__item"
      >
        <a-progress-step
          :action="step.action"
          :current="current === index"
          :number="index + 1"
          :status="step.status"
        >
          {{ step.title }}
        </a-progress-step>
      </li>
    </ol>

  </nav>
</template>

<script>
import AProgressStep from '@/components/atoms/AProgressStep'

export default {
  name: 'CProgress',

  components: {
    AProgressStep
  },

  props: {
    current: {
      type: Number,
      default: 0
    },
    /*
      [
        {
          title: 'Hello World',
          [status: this.$config.status.SUCCESS || this.$config.status.ERROR],
          [action: function () { … }]
        },
        {
          title: 'Hello Kitty'
        },
        …
      ]
    */
    steps: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      expanded: false,
      id: `progress-list-${this._uid}`
    }
  }
}
</script>

<style scoped>
.progress {
  margin: var(--grid-spacing) -2px;
}

.progress__button {
  display: block;
  position: relative;
  width: 100%;
  margin-bottom: calc(var(--grid-spacing) / 2);
  padding: 6px;

  text-align: left;

  background: var(--color-brand-pale);
  border: 0;
  border-radius: 18px;
}

.progress__button::after {
  content: "";

  position: absolute;
  width: 16px;
  height: 16px;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);

  background: url("~@/assets/progress-expand.svg") center / 100% no-repeat;
}

.progress__button.is-expanded::after {
  transform: translateY(-50%) rotate(180deg);
}

@media (min-width: 900px) {
  .progress__button {
    display: none;
  }
}

.progress__button-chip {
  display: inline-block;
  margin-right: 5px;
  padding: 3px 8px;

  color: #fff;

  background-color: var(--color-brand);
  border-radius: 12px;
}

.progress__list {
  list-style: none;

  display: none;
  margin: 0;
  padding: 0;
}

.progress__list.is-expanded {
  display: block;
}

@media (min-width: 900px) {
  .progress__list,
  .progress__list.is-expanded {
    display: flex;
    align-items: center;
  }
}

.progress__item:not(:last-child)::after {
  content: "";

  display: block;
  width: 2px;
  height: 16px;
  margin: 0 17px;

  background-color: var(--color-brand-pale);
}

@media (min-width: 900px) {
  .progress__item {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }

  .progress__item:last-child {
    flex-grow: 0;
  }

  .progress__item:not(:last-child)::after {
    flex-grow: 1;
    height: 2px;
    margin: 0;
  }
}
</style>
